"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHostname = getHostname;
function getHostname() {
  if (typeof window !== 'undefined') {
    return window.location.hostname;
  }
  return '';
}